import { Locale } from 'modules/i18n';

export const bannerTranslation = {
  [Locale.en]: {
    text: 'Effective June 23, interaction with Scroll and Sonic is available to <a href={href} target="_blank">Premium plan</a> users only.',
  },
};
